module.exports = __webpack_public_path__ + "static/media/undraw_Bookshelves_re_lxoy.348d66fd.svg";